/* Verkaufsbaustein: Bundle-Auswahl, Warenkorb-Schublade, Pop-up, Sticky-Knopf, Countdown, Bewegung.
   Inhalte kommen aus #imp-data (Produkt) und #imp-config (Angebot). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var dataEl = $('#imp-data'), cfgEl = $('#imp-config');
  if (!dataEl || !cfgEl) return;
  var data = JSON.parse(dataEl.textContent), cfg = JSON.parse(cfgEl.textContent);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (c) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' }).format(c / 100);
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  };
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* Angebot */
  var dealEnd = cfg.dealEnd ? Date.parse(cfg.dealEnd) : 0;
  var dealOver = dealEnd && Date.now() > dealEnd;
  var tiers = dealOver ? [Object.assign({}, cfg.tiers[0], { pct: 0, title: cfg.tiers[0].afterTitle || cfg.tiers[0].title, sub: cfg.tiers[0].afterSub || cfg.tiers[0].sub })] : cfg.tiers;
  var tierIdx = dealOver ? 0 : (cfg.defaultTier || 0);
  var variants = data.variants;
  var hasPickers = variants.length > 1;
  var basePrice = (cfg.unitPrice && data.currency === (cfg.unitCurrency || 'USD')) ? cfg.unitPrice : variants[0].price;
  var rows = (cfg.rowDefaults || []).map(function (r) { return r.slice(); });
  if (!rows.length) rows = [variants[0].options.slice()];
  var variantOf = function (opts) {
    return variants.filter(function (v) { return v.options.join('|') === opts.join('|'); })[0];
  };
  var calc = function (t) {
    var full = basePrice * t.qty;
    var final = Math.round(full * (1 - (t.pct || 0) / 100));
    return { full: full, final: final, save: full - final, each: Math.round(final / t.qty) };
  };

  var renderTiers = function () {
    var box = $('[data-imp-tiers]');
    if (!box) return;
    box.innerHTML = tiers.map(function (t, i) {
      var c = calc(t);
      return '<button type="button" class="imp-tier' + (i === tierIdx ? ' is-on' : '') + '" role="radio" aria-checked="' + (i === tierIdx) + '" data-tier="' + i + '">' +
        (t.badge ? '<span class="imp-tier__badge">' + esc(t.badge) + '</span>' : '') +
        '<span class="imp-tier__dot"></span>' +
        '<span class="imp-tier__txt"><strong>' + esc(t.title) + '</strong><small>' + esc(t.sub) + '</small>' +
        (t.free ? '<em class="imp-tag">FREE SHIPPING</em>' : '') + '</span>' +
        '<span class="imp-tier__price"><strong>' + money(c.final) + '</strong>' +
        (c.save ? '<s>' + money(c.full) + '</s><em class="imp-save">Save ' + money(c.save) + '</em>' : (t.note ? '<small>' + esc(t.note) + '</small>' : '')) +
        '</span></button>';
    }).join('');
    $$('.imp-tier', box).forEach(function (el) {
      el.addEventListener('click', function () { setTier(+el.getAttribute('data-tier')); });
    });
    renderTierMedia(box);
  };

  /* Optional: Bilder unter der Bundle-Auswahl, wenn eine Stufe "media" hat */
  var tierMediaKey = null;
  var renderTierMedia = function (box) {
    if (!tiers.some(function (t) { return t.media && t.media.length; })) return;
    var pan = $('[data-imp-tmedia]');
    if (!pan) {
      pan = document.createElement('div');
      pan.className = 'imp-tmedia';
      pan.setAttribute('data-imp-tmedia', '');
      pan.innerHTML = '<div class="imp-tmedia__in"></div>';
      box.parentNode.insertBefore(pan, box.nextSibling);
    }
    var t = tiers[tierIdx], m = t.media || [];
    var inner = pan.firstChild;
    if (m.length && tierMediaKey !== tierIdx) {
      inner.innerHTML = '<div class="imp-tmedia__grid">' + m.map(function (x) {
        return '<figure><img src="' + esc(x.src) + '" alt="' + esc(x.alt || x.cap || '') + '" loading="lazy" decoding="async">' +
          (x.cap ? '<figcaption>' + esc(x.cap) + '</figcaption>' : '') + '</figure>';
      }).join('') + '</div>' + (t.mediaNote ? '<p class="imp-tmedia__note">' + esc(t.mediaNote) + '</p>' : '');
      tierMediaKey = tierIdx;
    }
    var open = !!m.length;
    pan.classList.toggle('is-open', open);
    pan.setAttribute('aria-hidden', String(!open));
  };

  var bigImg = function (u) {
    return u ? String(u).replace(/([?&])width=\d+/, '$1width=480').replace(/_(\d+)x(\d*)\./, '_480x.') : u;
  };

  var renderPickers = function () {
    var box = $('[data-imp-pickers]');
    if (!box || !hasPickers) return;
    var t = tiers[tierIdx];
    var names = data.optionNames;
    var html = '';
    for (var i = 0; i < t.qty; i++) {
      var r = rows[i] || rows[0].slice();
      rows[i] = r;
      var v = variantOf(r) || variants[0];
      html += '<div class="imp-row">' +
        '<img class="imp-row__img" data-row-img="' + i + '" src="' + esc(bigImg(v.image || data.image)) + '" alt="' + esc(r.join(' / ')) + '" width="120" height="120" loading="lazy">' +
        '<div class="imp-row__sel"><span class="imp-row__lab">' + esc(cfg.unitWord || 'Item') + ' ' + (i + 1) + '</span><div>';
      names.forEach(function (name, o) {
        var vals = data.optionValues[o];
        html += '<label><span class="imp-vh">' + esc(name) + '</span><select data-row="' + i + '" data-opt="' + o + '">' +
          vals.map(function (val) {
            return '<option value="' + esc(val) + '"' + (val === r[o] ? ' selected' : '') + '>' + esc(val) + '</option>';
          }).join('') + '</select></label>';
      });
      html += '</div></div></div>';
    }
    box.innerHTML = html;
    $$('select', box).forEach(function (s) {
      s.addEventListener('change', function () {
        var i = +s.getAttribute('data-row'), o = +s.getAttribute('data-opt');
        rows[i][o] = s.value;
        var v = variantOf(rows[i]);
        var img = $('[data-row-img="' + i + '"]', box);
        if (v && v.image && img) { img.src = bigImg(v.image); img.alt = rows[i].join(' / '); }
      });
    });
  };

  var renderPrices = function () {
    var t = tiers[tierIdx], c = calc(t);
    $$('[data-imp-now]').forEach(function (e) { e.textContent = money(c.final); });
    $$('[data-imp-was]').forEach(function (e) { e.textContent = c.save ? money(c.full) : ''; });
    $$('[data-imp-tiername]').forEach(function (e) { e.textContent = t.title; });
    $$('[data-imp-each]').forEach(function (e) { e.textContent = money(c.each) + (t.qty > 1 ? ' each' : ''); });
  };

  var setTier = function (i) {
    tierIdx = i;
    renderTiers();
    renderPickers();
    renderPrices();
  };

  /* Warenkorb */
  var items = function () {
    var t = tiers[tierIdx];
    if (!hasPickers) return [{ id: variants[0].id, quantity: t.qty }];
    var map = {};
    for (var i = 0; i < t.qty; i++) {
      var v = variantOf(rows[i] || rows[0]) || variants[0];
      map[v.id] = (map[v.id] || 0) + 1;
    }
    return Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
  };
  var post = function (path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Please try again.');
        return j;
      });
    });
  };
  var getCart = function () {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  };
  var showErr = function (msg) {
    $$('[data-imp-err]').forEach(function (e) { e.textContent = msg || ''; e.hidden = !msg; });
    var old = $('.imp-toast');
    if (old) old.remove();
    if (!msg) return;
    var t = document.createElement('div');
    t.className = 'imp-toast';
    t.setAttribute('role', 'alert');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 5000);
  };
  var release = function (btn) {
    btn.disabled = false;
    btn.classList.remove('is-busy');
  };
  var add = function (btn) {
    showErr('');
    btn.disabled = true;
    btn.classList.add('is-busy');
    return post('cart/add.js', { items: items() }).then(function () {
      burst(btn);
      return openDrawer();
    }).catch(function (e) { showErr(e.message); }).then(function () { release(btn); });
  };
  var buyNow = function (btn) {
    showErr('');
    btn.disabled = true;
    btn.classList.add('is-busy');
    return post('cart/clear.js', {}).then(function () {
      return post('cart/add.js', { items: items() });
    }).then(function () {
      window.location.href = root + 'checkout';
    }).catch(function (e) { showErr(e.message); release(btn); });
  };

  /* Schublade */
  var drawer = $('#imp-drawer');
  var count = function (n) {
    $$('[data-imp-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
  };
  var freeQty = cfg.freeQty || 0;
  var renderDrawer = function (cart) {
    if (!drawer) return;
    count(cart.item_count);
    var list = $('[data-imp-lines]', drawer);
    var foot = $('[data-imp-foot]', drawer);
    var bar = $('[data-imp-prog]', drawer);
    if (!cart.item_count) {
      list.innerHTML = '<div class="imp-empty"><p>' + esc(cfg.emptyText || 'Your cart is empty.') + '</p><button type="button" class="imp-cta" data-imp-close>Keep looking</button></div>';
      foot.hidden = true;
      bar.hidden = true;
      var upEmpty = $('[data-imp-upsell]', drawer);
      if (upEmpty) { upEmpty.hidden = true; upEmpty.innerHTML = ''; }
      return;
    }
    foot.hidden = false;
    var missing = Math.max(0, freeQty - cart.item_count);
    var saved = cart.total_discount || 0;
    bar.hidden = dealOver || !freeQty || (!missing && !saved);
    var pct = freeQty ? Math.min(100, Math.round(cart.item_count / freeQty * 100)) : 100;
    $('[data-imp-prog-txt]', drawer).innerHTML = missing
      ? esc(cfg.progressMore || 'Add {n} more for FREE shipping').replace('{n}', '<b>' + missing + '</b>')
      : esc(cfg.progressDone || '🎉 You unlocked FREE shipping!');
    $('[data-imp-prog-fill]', drawer).style.width = pct + '%';

    var active = tiers.filter(function (t) { return t.pct && cart.item_count >= t.qty; }).pop();
    list.innerHTML = cart.items.map(function (it, i) {
      var was = it.original_line_price > it.final_line_price;
      return '<div class="imp-line">' +
        '<img src="' + esc(it.image) + '" alt="" width="72" height="72" loading="lazy">' +
        '<div class="imp-line__mid"><strong>' + esc(it.product_title) + '</strong>' +
        (it.variant_title ? '<small>' + esc(it.variant_title) + '</small>' : '') +
        '<div class="imp-qty"><button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="One less">−</button><span>' + it.quantity + '</span>' +
        '<button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button></div></div>' +
        '<div class="imp-line__price"><strong>' + money(it.final_line_price) + '</strong>' + (was ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</div></div>';
    }).join('') +
      ((active && saved) ? '<div class="imp-won">🎁 ' + esc(active.won || active.title) + ' applied</div>' : '');

    var up = $('[data-imp-upsell]', drawer);
    var next = tiers.filter(function (t) { return t.pct && t.qty > cart.item_count; })[0];
    if (up) {
      if (next && !dealOver) {
        var n = next.qty - cart.item_count;
        up.hidden = false;
        up.innerHTML = '<div><strong>' + esc(next.title) + '</strong><small>' + esc((cfg.upsellText || 'Add {n} more and save').replace('{n}', n)) + ' ' + money(calc(next).save) + ' in total</small></div>' +
          '<button type="button" data-imp-upgrade="' + n + '" data-tier-to="' + tiers.indexOf(next) + '">' + (hasPickers ? 'Choose' : 'Add ' + n) + '</button>';
      } else {
        up.hidden = true;
        up.innerHTML = '';
      }
    }
    var sv = $('[data-imp-saved]', drawer);
    sv.hidden = !saved;
    $('[data-imp-saved-val]', drawer).textContent = '-' + money(saved);
    $('[data-imp-sub]', drawer).textContent = money(cart.total_price);
    $('[data-imp-checkout]', drawer).textContent = 'Checkout • ' + money(cart.total_price);
    var ship = $('[data-imp-shipnote]', drawer);
    if (ship) ship.textContent = (!missing && freeQty && !dealOver && saved) ? 'Shipping: FREE' : 'Shipping shown at checkout';
  };
  var lastFocus;
  var openDrawer = function () {
    if (!drawer) return Promise.resolve();
    closePopup();
    lastFocus = document.activeElement;
    return getCart().then(function (c) {
      renderDrawer(c);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('imp-lock');
      var x = $('[data-imp-close]', drawer);
      if (x) x.focus();
    });
  };
  var closeDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('imp-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-imp-add],[data-imp-buynow],[data-imp-cart],[data-imp-close],[data-line],[data-imp-upgrade],[data-imp-menu],[data-imp-goto]') : null;
    if (!t) return;
    if (t.hasAttribute('data-imp-add')) { e.preventDefault(); add(t); return; }
    if (t.hasAttribute('data-imp-buynow')) {
      e.preventDefault();
      buyNow(t);
      return;
    }
    if (t.hasAttribute('data-imp-cart')) { e.preventDefault(); openDrawer(); return; }
    if (t.hasAttribute('data-imp-close')) { e.preventDefault(); closeDrawer(); return; }
    if (t.hasAttribute('data-line')) {
      t.disabled = true;
      post('cart/change.js', { id: t.getAttribute('data-line'), quantity: +t.getAttribute('data-q') }).then(renderDrawer).catch(function (err) {
        showErr(err.message);
        getCart().then(renderDrawer);
      });
      return;
    }
    if (t.hasAttribute('data-imp-upgrade')) {
      t.disabled = true;
      if (hasPickers) {
        /* Bei Motiven und Größen wählt der Kunde die zusätzlichen Stücke selbst */
        getCart().then(function (c) {
          var chosen = [];
          c.items.forEach(function (it) {
            var v = variants.filter(function (x) { return x.id === it.variant_id; })[0];
            for (var q = 0; v && q < it.quantity; q++) chosen.push(v.options.slice());
          });
          chosen.forEach(function (o, i) { rows[i] = o; });
          return post('cart/clear.js', {});
        }).then(function (c) {
          setTier(+t.getAttribute('data-tier-to'));
          count(0);
          closeDrawer();
          var pick = $('[data-imp-pickers]');
          if (pick) pick.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
        }).catch(function (err) { showErr(err.message); t.disabled = false; });
        return;
      }
      getCart().then(function (c) {
        return post('cart/change.js', { id: c.items[0].key, quantity: c.items[0].quantity + (+t.getAttribute('data-imp-upgrade')) });
      }).then(renderDrawer).catch(function (err) {
        showErr(err.message);
        getCart().then(renderDrawer);
      });
      return;
    }
    if (t.hasAttribute('data-imp-menu')) {
      var m = $('#imp-menu');
      if (m) m.classList.toggle('is-open');
      return;
    }
    if (t.hasAttribute('data-imp-goto')) {
      var m2 = $('#imp-menu');
      if (m2) m2.classList.remove('is-open');
      var g = $('#imp-buy');
      if (g) { e.preventDefault(); g.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' }); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    closePopup();
    var m = $('#imp-menu');
    if (m) m.classList.remove('is-open');
  });

  /* Pop-up */
  var popup = $('#imp-popup');
  var closePopup = function () { if (popup) popup.classList.remove('is-open'); };
  if (popup && !dealOver && !store.get('imp_popup')) {
    setTimeout(function () {
      if (drawer && drawer.classList.contains('is-open')) return;
      popup.classList.add('is-open');
      store.set('imp_popup', '1');
    }, cfg.popupDelay == null ? 900 : cfg.popupDelay);
  }
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup || (e.target.closest && e.target.closest('[data-imp-popclose]'))) closePopup();
      if (e.target.closest && e.target.closest('[data-imp-claim]')) {
        closePopup();
        setTier(cfg.defaultTier || 0);
        var box = $('.imp-bt') || $('#imp-buy');
        if (box) box.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
        var on = $('.imp-tier.is-on');
        if (on) { on.classList.add('is-pulse'); setTimeout(function () { on.classList.remove('is-pulse'); }, 1600); }
      }
    });
  }

  /* Countdown auf das echte Ende des Angebots */
  var cds = $$('[data-imp-countdown]');
  if (cds.length) {
    if (!dealEnd || dealOver) {
      $$('[data-imp-dealonly]').forEach(function (e) { e.hidden = true; });
    } else {
      var tick = function () {
        var s = Math.max(0, Math.floor((dealEnd - Date.now()) / 1000));
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
        var two = function (n) { return (n < 10 ? '0' : '') + n; };
        var html = (d ? '<b>' + d + '</b>d ' : '') + '<b>' + two(h) + '</b>h <b>' + two(m) + '</b>m <b>' + two(ss) + '</b>s';
        cds.forEach(function (c) { c.innerHTML = html; });
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  /* Lieferfenster ab heute, Werte vom Lieferanten */
  if (cfg.eta) {
    var fmt = function (days) {
      var d = new Date(Date.now() + days * 86400000);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };
    var latest = new Date(Date.now() + cfg.eta[1] * 86400000);
    var earliest = new Date(Date.now() + cfg.eta[0] * 86400000);
    var eve = new Date(new Date().getFullYear(), 11, 24, 23, 59);
    var txt = 'Order today, estimated delivery ' + fmt(cfg.eta[0]) + ' to ' + fmt(cfg.eta[1]) + '.';
    if (Date.now() < eve.getTime()) {
      if (earliest > eve) txt += ' This will arrive after Christmas.';
      else if (latest > eve) txt += ' It may arrive after Christmas.';
      else txt += ' In time for Christmas.';
    }
    $$('[data-imp-eta]').forEach(function (e) { e.textContent = txt; });
  }

  /* Sticky-Knopf */
  var sticky = $('#imp-sticky'), cta = $('#imp-cta');
  if (sticky && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      sticky.classList.toggle('is-on', !en[0].isIntersecting);
    }, { threshold: 0 }).observe(cta);
  }

  /* Galerie */
  $$('[data-imp-gallery]').forEach(function (g) {
    var track = $('.imp-slides', g), dots = $$('.imp-dots i', g);
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }, { passive: true });
  });

  /* Einblenden beim Scrollen */
  if ('IntersectionObserver' in window && !calm) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.imp-r').forEach(function (e) { io.observe(e); });
  } else {
    $$('.imp-r').forEach(function (e) { e.classList.add('is-in'); });
  }

  /* Freude beim Klick */
  function burst(from) {
    if (calm || !cfg.burst || !cfg.burst.length) return;
    var r = from.getBoundingClientRect();
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('span');
      s.className = 'imp-burst';
      s.textContent = cfg.burst[i % cfg.burst.length];
      s.style.left = (r.left + r.width / 2) + 'px';
      s.style.top = (r.top + r.height / 2) + 'px';
      s.style.setProperty('--x', (Math.random() * 280 - 140) + 'px');
      s.style.setProperty('--y', (-120 - Math.random() * 240) + 'px');
      s.style.setProperty('--r', (Math.random() * 360 - 180) + 'deg');
      document.body.appendChild(s);
      (function (n) { setTimeout(function () { n.remove(); }, 1000); })(s);
    }
  }

  /* Teilchen im ersten Bild: Schnee, Goldfunken oder Leuchten */
  $$('canvas[data-imp-fx]').forEach(function (c) {
    if (calm) return;
    var kind = c.getAttribute('data-imp-fx');
    var ctx = c.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var W, H, parts = [], run = false;
    var size = function () {
      W = c.width = c.clientWidth * dpr;
      H = c.height = c.clientHeight * dpr;
    };
    size();
    window.addEventListener('resize', size);
    var make = function (fresh) {
      var p = { x: Math.random() * W, y: fresh ? Math.random() * H : (kind === 'snow' ? -10 : H + 10), r: (kind === 'glow' ? 1.5 + Math.random() * 4 : 0.8 + Math.random() * 2.4) * dpr, s: (0.2 + Math.random() * 0.7) * dpr, w: Math.random() * 6.28, a: 0.25 + Math.random() * 0.6 };
      return p;
    };
    var n = kind === 'snow' ? 46 : 30;
    for (var i = 0; i < n; i++) parts.push(make(true));
    var colors = { gold: '255,214,140', snow: '255,255,255', glow: '150,190,255' };
    var loop = function (t) {
      if (!run) return;
      ctx.clearRect(0, 0, W, H);
      parts.forEach(function (p, i) {
        p.w += 0.012;
        p.x += Math.sin(p.w) * 0.35 * dpr;
        p.y += kind === 'snow' ? p.s : -p.s * 0.7;
        var tw = kind === 'snow' ? 1 : 0.55 + 0.45 * Math.sin(t / 420 + i);
        var col = kind === 'glow' ? (i % 3 === 0 ? '120,240,230' : i % 3 === 1 ? '190,150,255' : '255,160,230') : colors[kind];
        ctx.beginPath();
        ctx.fillStyle = 'rgba(' + col + ',' + (p.a * tw) + ')';
        ctx.arc(p.x, p.y, p.r, 0, 6.28);
        ctx.fill();
        if (p.y > H + 12 || p.y < -12) parts[i] = make(false);
      });
      requestAnimationFrame(loop);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var on = en[0].isIntersecting;
        if (on && !run) { run = true; requestAnimationFrame(loop); } else if (!on) { run = false; }
      }).observe(c);
    } else { run = true; requestAnimationFrame(loop); }
  });

  /* Start */
  renderTiers();
  renderPickers();
  renderPrices();
  getCart().then(function (c) { count(c.item_count); }).catch(function () {});
})();
